// extracted by mini-css-extract-plugin
export var baseButton = "_qb-0";
export var controlsArrowKeys = "_qb-1";
export var controlsResetButton = "_qb-2";
export var lightGameButton = "_qb-4 _qb-0";
export var playAgainButton = "_qb-5 _qb-0";
export var startGameButton = "_qb-3 _qb-0";